<template>
  <el-dialog title="合同信息" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span class="titlecolor">基本信息</span>
          </template>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="合同名称" :label-width="formLabelWidth" prop="pname">
                <el-input v-model="form.pname" auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同编号" :label-width="formLabelWidth" prop="erpserial">
                <el-input v-model="form.erpserial" placeholder="系统自动生成" auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="!form.parenterpserial">
            <el-col :span="16">
              <el-form-item label="门店" :label-width="formLabelWidth" prop="customerserial">
                <AutoCustomer @handleSelect="selectExternalDept" :content="form.customername"></AutoCustomer>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="合同金额" :label-width="formLabelWidth" prop="htje">
                <el-input-number :min="0" :precision="2" v-model="form.htje" :controls="false" style="width:125px;"
                ></el-input-number>
                元
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签订日期" :label-width="formLabelWidth" prop="htqd">
                <el-date-picker
                  v-model="form.htqd" :value-format="'yyyy-MM-dd'" style="width:140px;"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="截止日期" :label-width="formLabelWidth" prop="jhjgrq">
                <el-date-picker
                  v-model="form.jhjgrq" :value-format="'yyyy-MM-dd'" style="width:140px;"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="form.parenterpserial">
            <el-col :span="8">
              <el-form-item label="计入主合同额" :label-width="formLabelWidth" prop="returntype">
                <el-checkbox v-model="form.returntype==1" @change="changeReturntype"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="form.casestatus>=6">
            <el-col :span="8">
              <el-form-item label="返利金额" :label-width="formLabelWidth" prop="yfk">
                <el-input-number :min="0" :precision="2" v-model="form.yfk" :controls="false" style="width:125px;"
                                 :disabled="!financeright"
                ></el-input-number>
                元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="附件" :label-width="formLabelWidth" prop="casefvid">
                <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.casefvid"  groupType="salecontract" :limit="10"></CommonUpload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.remark" :controls="false"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">合同明细
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(0)"
              v-if="canedit">添加商品</span>
          <span style="margin-right: 10px;float: right"
                @click.stop.prevent="showGoodCategorySel" v-if="canedit">添加类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="170">
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="产品名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column label="下单方式" align="center" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.filltemplate" :size="'mini'" placeholder="请选择"
                             v-if="scope.row.seedcode==null||scope.row.seedcode==''">
                    <el-option
                      v-for="item in ftype"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="返利点" align="center" width="100">
                <template slot-scope="scope">
                  <el-input-number :min="0" :max="100" :size="'mini'" :precision="2" v-model="scope.row.rebatepercent"
                                   :controls="false"
                                   style="width:80px;"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80" v-if="canedit">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row,0)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">特价产品
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(1)"
              v-if="canedit">添加商品</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataSkim"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="产品类别"
                align="left"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column
                label="产品名称"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.seedcode}} {{scope.row.seedname}}
                </template>
              </el-table-column>
              <el-table-column label="计入合同总额" align="center" width="95">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.iscontractmoney==1" @change="changeContract(scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="计入返利" align="center" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isrebate==1" @change="changeRebate(scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="返利点" align="center" width="100">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.row.isrebate==1" :min="0" :max="100" :size="'mini'" :precision="2"
                                   v-model="scope.row.rebatepercent"
                                   :controls="false"
                                   style="width:80px;"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="单价" align="center" width="100">
                <template slot-scope="scope">
                  <el-input-number :size="'mini'" :precision="2"
                                   v-model="scope.row.fixmoney"
                                   :controls="false"
                                   style="width:80px;"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80" v-if="canedit">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row,1)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" ref="bt1" v-if="canedit&&!isSupply()&&isShowSaveBtn()" :loading="loading"
                 @click="saveData()">保 存
      </el-button>
      <el-button type="primary" ref="bt2"
                 v-if="canedit&&form.casestatus==0&&isZongBu()&&form.unitguid&&!isSupply()&&financeright"
                 :loading="loading" @click="saveData(6)">
        审批通过
      </el-button>
      <el-button type="primary" ref="bt3" v-if="canedit&&form.casestatus==6&&isZongBu()&&!isSupply()&&financeright"
                 :loading="loading" @click="saveData(9)">
        确认返利
      </el-button>
      <el-button type="warning" ref="bt4" v-if="form.unitguid&&form.casestatus!=-1"
                 :loading="loading" @click="xuqian">
        续签
      </el-button>
      <el-button type="danger" ref="bt4" v-if="form.unitguid&&form.casestatus==6"
                 :loading="loading" @click="endContract(-1)">
        终止
      </el-button>
    </div>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"
                      @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" :isShowCheckBox="true"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    <ExternaldeptSel ref="externalsel" :unitgroup="1" :title="'选择门店'" @select="selectExternalDept"></ExternaldeptSel>
  </el-dialog>
</template>


<script>
  import {saveData, getDetail} from '@/api/order/salecontract';
  import {getTemplate} from '@/api/set/salefavour';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'
  import {attUUID} from '@/api/attachment';

  let date1 = new Date()
  let date2 = date1.getFullYear() + "-" + ((date1.getMonth() < 9 ? "0" : "") + (date1.getMonth() + 1)) + "-" + ((date1.getDate() < 10 ? "0" : "") + date1.getDate())
  export default {
    name: "DataContactEdit",
    data() {
      return {
        dialogFormVisible: false,
        activeNames: ['1', '2', '3'],
        tableData: [],
        tableDataSkim: [],//撇除的产品
        delUnitguids: [],
        loading: false,//控制按钮显示
        canedit: true,
        financeright: false,
        form: {  //表单数据
          uguid: "",
          unitguid: '',
          pname: "",//合同名称
          erpserial: "",//订单编号，自动生成
          htqd: date2,//签订日期
          jhjgrq: "",//截止日期
          handleoverdate: "",//返利时间
          htje: "",//合同金额
          yfk: "",//实际返利金额
          remark: "",
          formtype: 41,//41表示销售合同
          customername: "",//门店名称
          customerserial: "",//门店编码
          returntype: 0,//1表示计入主合同，0表示不计入
          parenterpserial: "",//关联上游合同
          parentguid: "",//关联上游合同,
          applybydserial: "",//门店所属服务部门编号
          applybydname: "",//门店所属服务部门名称
          casestatus: 0, //0,6,9 对应 待审核、执行中、已返利
          casefvid:'',
          casestepname: ""  //待审核、执行中、已返利
        },
        ftype: [
          {
            value: '10',
            name: "现片"
          },
          {
            value: '20',
            name: "定制"
          },
          {
            value: '50',
            name: "加工"
          },
          {
            value: '60',
            name: "特殊加工"
          },
          {
            value: '40',
            name: "数量选择"
          },
          // {
          //   value: '30',
          //   name: "区分左右眼"
          // },
        ],
        formLabelWidth: '120px',
        isSkim: 0,//1表示添加撇除产品
        userInfoModel: {},//缓存数据
        tokenModel: {},
        rules: {
          htje: [
            {required: true, message: '合同金額必填', trigger: 'blur'},
          ],
          pname: [
            {required: true, message: '请填写合同名称', trigger: 'blur'},
          ],
          jhjgrq: [
            {required: true, message: '截止日期必填', trigger: 'blur'},
          ],
          htqd: [
            {required: true, message: '签订日期必填', trigger: 'blur'},
          ],
          customerserial: [
            {required: true, message: '门店必填', trigger: 'change'},
          ],
        },
      }
    },
    methods: {
      isSupply() {
        return this.tokenModel.loginfrom == 'supply'
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      //控制显示保存按钮
      isShowSaveBtn() {
        if ((((this.form.unitguid && this.form.uguid == this.userInfoModel.uguid) || !this.form.unitguid) && this.form.casestatus == 0) || (this.form.casestatus == 6 && this.financeright)) {
          return true
        }
        return false
      },
      //打开此页面
      show(parenterpserial, parentguid, customeserial, customername) {
        this.form.casefvid = attUUID();
        if (parenterpserial) {
          this.form.parenterpserial = parenterpserial
          this.form.parentguid = parentguid
          this.form.customerserial = customeserial
          this.form.customername = customername
          delete this.rules.customerserial
        } else {//新增加得时候 初始化
          getTemplate().then(response => {
            if (response.data.code == 0) {
              for (var i = 0; i < response.data.obj.saleList.length; i++) {
                var arr = response.data.obj.saleList[i];
                this.tableDataSkim.push({
                  isskim: 1,
                  categoryname: arr.categoryname,
                  seedcode: arr.seedcode,
                  seedname: arr.seedname,
                  iscontractmoney: 1,
                  categorycode: arr.categorycode,
                  fixmoney: arr.fixmoney
                })
              }
            }
          });
        }
        this.dialogFormVisible = true
      },
      //删除明细
      handleDelete(index, row, isSkim) {
        if (isSkim == 1) {
          this.tableDataSkim.splice(index, 1)
        } else {
          //如果删除的是类别，则要判断此类别下面是否有特价商品，如果有，则必须先删除特价商品才能删除此类别
          if (!row.seedcode) {
            for (let i in this.tableDataSkim) {
              if (this.tableDataSkim[i].categorycode.startsWith(row.categorycode)) {
                this.$message({
                  message: "该类别下存在特价商品，无法删除该类别",
                  type: 'warning',
                  duration: 1500
                })
                return
              }
            }
          }
          this.tableData.splice(index, 1)
        }
        if (row.unitguid) {
          this.delUnitguids.push(row.unitguid)
        }
      },
      //点击是否计入主合同
      changeContract(row) {
        if (row.iscontractmoney == 1) {
          this.$set(row, "isrebate", 0)
          this.$set(row, "rebatepercent", 0)
        }
        this.$set(row, "iscontractmoney", row.iscontractmoney == 1 ? 0 : 1)
      },
      //点击是否返利
      changeRebate(row) {
        this.$set(row, "rebatepercent", 0)
        if (!row.isrebate) {
          this.$set(row, "iscontractmoney", 1)
        }
        this.$set(row, "isrebate", row.isrebate == 1 ? 0 : 1)
      },
      //点击是否计入主合同
      changeReturntype() {
        this.form.returntype = this.form.returntype == 1 ? 0 : 1
      },
      //显示商品选择页面
      showGoodDetailSel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        if (this.isSkim == 1) {
          this.afterSelectSkim(arr)
          return
        }
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if ((!this.tableData[j].seedcode && arr[i].categorycode.startsWith(this.tableData[j].categorycode)) || (this.tableData[j].seedcode && this.tableData[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode
            })
          }
        }
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info',
            duration: 1500
          })
        }

      },
      //选择特价商品之后执行
      afterSelectSkim(arr) {
        let count = 0;
        let i = this.tableDataSkim.length
        label1:
          for (let i in arr) {
            let biaoji = 0
            for (let j in this.tableDataSkim) {
              //判读该特价商品是否已经添加
              if (this.tableDataSkim[j].seedcode == arr[i].seedcode) {
                biaoji = 1
                count++
                continue label1
              }
            }

            if (biaoji == 0) {
              //判断该特价商品不能是合同明细中的商品
              for (let g in this.tableData) {
                if (this.tableData[g].seedcode && arr[i].seedcode == this.tableData[g].seedcode) {
                  biaoji = 1
                  count++
                  continue label1
                }
              }
            }

            if (biaoji == 0) {
              let temp = 0
              for (let g in this.tableData) {
                //判读特价的商品必须属于合同明细下的类别
                if (!this.tableData[g].seedcode && arr[i].categorycode.startsWith(this.tableData[g].categorycode)) {
                  temp = 1
                  this.tableDataSkim.push({
                    isskim: 1,
                    categoryname: arr[i].lname,
                    seedcode: arr[i].seedcode,
                    seedname: arr[i].seedname,
                    categorycode: arr[i].categorycode,
                    fixmoney: ''
                  })
                  break
                }
              }
              if (temp == 0) {
                count++
              }
            }
          }
        if (count > 0) {
          this.$message({
            message: "该特价商品已存在，或者合同明细中已存在，或者不属于合同明细类别下的商品",
            type: 'info',
            duration: 1500
          })
        }
      },
      //选择门店
      selExternal() {
        this.$refs.externalsel.show()
      },
      //选择门店回调
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserial = customerserial;
        this.form.customername = deptname;
      },
      //选择商品类别
      showGoodCategorySel(arr) {
        this.$refs.JxcgoodscategorySel.show()
      },
      //选择商品类别后执行
      afterSelectCategoryCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            if ((!this.tableData[j].seedcode && (arr[i].categorycode.startsWith(this.tableData[j].categorycode) || this.tableData[j].categorycode.startsWith(arr[i].categorycode)) && arr[i].categorycode != this.tableData[j].categorycode) || (this.tableData[j].seedcode && this.tableData[j].categorycode.startsWith(arr[i].categorycode))) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({categorycode: arr[i].categorycode, categoryname: arr[i].categoryname})
          }
        }
        if (count > 0) {
          this.$message({
            message: "该商品类别已经存在父类别、子类别或该类别下的商品",
            type: 'info',
            duration: 1500
          })
        }
      },
      //续签
      xuqian() {
        this.form.unitguid = ''
        this.form.erpserial = ''
        this.form.htqd = ''
        this.form.jhjgrq = ''
        this.form.parenterpserial = ''
        this.form.casestatus = 0
        if (this.tableData.length > 0) {
          for (let i in this.tableData) {
            this.tableData[i].erpserial = ''
            this.tableData[i].unitguid = ''
          }
        }
        if (this.tableDataSkim.length > 0) {
          for (let i in this.tableDataSkim) {
            this.tableDataSkim[i].erpserial = ''
            this.tableDataSkim[i].unitguid = ''
          }
        }
        this.$nextTick(() => {
          this.show();
        })
      },
      endContract(){
        this.$confirm('是否确定终止合同?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveData(-1);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      },
      //保存
      saveData(casestatus1) {
        this.loading = true
        if (this.tableData.length == 0) {
          this.$message({
            message: "请选择合同明细",
            type: 'info',
            duration: 1500
          })
          this.refreshBtn()
          return
        }

        if (this.form.htje == 0) {
          this.$message({
            message: "合同金额必须大于0",
            type: 'info',
            duration: 1500
          })
          this.refreshBtn()
          return
        }

        for (let i in this.tableData) {
          if (!this.tableData[i].seedcode && !this.tableData[i].filltemplate) {
            this.$message({
              message: "下单方式必须选择",
              type: 'info',
              duration: 1500
            })
            this.refreshBtn()
            return
          }
        }

        this.$refs.form1.validate((valid) => {
          if (valid) {
            if (this.form.htqd.indexOf("00:00") == -1) {
              this.form.htqd = this.form.htqd + " 00:00:00"
            }
            if (this.form.jhjgrq.indexOf("00:00") == -1) {
              this.form.jhjgrq = this.form.jhjgrq + " 00:00:00"
            }

            if (casestatus1) {
              this.form.casestatus = casestatus1
            }
            let data1 = {
              form: JSON.stringify(this.form),
              detail: JSON.stringify(this.tableData.concat(this.tableDataSkim)),
              delunitguids: JSON.stringify(this.delUnitguids)
            }
            saveData(data1).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1500
                })
                this.dialogFormVisible = false;
                //刷新列表
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
                this.refreshBtn()
              }
            });
          } else {
            this.refreshBtn()
          }
        })
      },
      //刷新按钮
      refreshBtn() {
        this.loading = false
      },
      //绑定查看数据
      initData(unitguid, canedit) {
        this.initForm()
        if (typeof canedit != 'undefined') {
          this.canedit = canedit
        }
        this.dialogFormVisible = true
        this.form.unitguid = unitguid
        getDetail({unitguid: unitguid}).then(response => {
          for (let i in this.form) {
            this.form[i] = response.data.obj.form[i]
          }
          if (!this.form.casefvid || this.form.casefvid == '') {
            this.form.casefvid = this.form.unitguid;
          }
          //明细
          response.data.obj.detail.forEach(o => {
            if (o.isskim == 1) {
              this.tableDataSkim.push(o)
            } else {
              this.tableData.push(o)
            }
          })
        });
      },
      //初始化
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.refreshBtn()
        this.canedit = true
        this.form.unitguid = ""
        this.tableData = []
        this.tableDataSkim = []
        this.delUnitguids = []
        this.form.customerserial = ""
        this.form.customername = ""
        this.form.parentguid = ""
        this.form.parenterpserial = ""
        this.form.returntype = 0
        this.form.applybydserial = ""
        this.form.applybydname = ""
        this.form.casestatus = 0
        if (this.rules["customerserial"] == null) {
          this.rules.customerserial = [
            {required: true, message: '门店必填', trigger: 'change'},
          ]
        }
      },

    },


    mounted() {
      this.tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.financeright = this.$checkRight('财务')
    },
    components: {
      JxcgooddetailSel,
      JxcgoodscategorySel,
      ExternaldeptSel,
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/salecontract/SaleContractEdit.vue